export default __webpack_public_path__ + "static/BitterBold-1faea0961beaedddd51ba829a606664b.ttf";